<template>
    <div>
        <base-crud
            crudName="Status de Veículos"
            newText="Novo Status de Veículo"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                table: 'vehicleStatusTable',
                // pages: [],
                // url: '',
                columns: [
                  'id',
                  'description',
                  'actions'
                ],
                tableData: [
                  'id',
                  'description'
                ],
                options: {
                    filterByColumn: true,
                    sortable: ['id', 'description'],
                    filterable: ['id', 'description'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                      'id': 'ID',
                      'description': 'Descrição',
                      'actions': 'Ações'
                    }
                },
                endPoint: 'vehicleStatus/',

                dataForm: {}
            }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/VehicleStatus/Crud.vue